// Client-side mirror of server's spoolRefFromFilename in
// drawingExtraction.ts. Used by the DrawingsTab to surface
// "Create spool" affordances for drawings whose filename carries a
// recognisable spool ref, without round-tripping to the server.
//
// Keep the regex set in sync with FALLBACK_PATTERNS on the server.
// The trailing `(?:-?[A-Z])?` accommodates sub-spool refs in either
// form (CPL-CHW-8913A or CPL-CHW-8913-A) — without it `\b` anchors
// before the letter and the suffix is silently dropped.
const FALLBACK_PATTERNS = [
  /\bSP[-_]?\d{1,4}(?:-?[A-Z])?\b/i,
  /\b[A-Z]{1,4}[-_][A-Z]{1,4}[-_]\d{2,6}(?:-?[A-Z])?\b/,
];

export function spoolRefFromFilename(filename: string): string | null {
  const base = filename.replace(/\.[^./\\]+$/u, "").replace(/^.*[\\/]/u, "");
  for (const pat of FALLBACK_PATTERNS) {
    const m = pat.exec(base);
    if (m?.[0]) return m[0].toUpperCase();
  }
  return null;
}
